import { QuestionnaireType } from "../../../../../../../api/graphql/schema.generated";

export interface QuestionnaireInfo {
  type: QuestionnaireType;
  title: string;
  description: string;
  notAvailable?: boolean;
  firstSupportedYear?: number;
  lastSupportedYear?: number;
  showOnlyIfMatch?: boolean;
}

export const QUESTIONNAIRES_INFO: Array<QuestionnaireInfo> = [
  {
    type: QuestionnaireType.EOY_BASIC_DATA,
    title: "Stammdaten",
    description: "Prüfung und Aktualisierung Kundendaten",
  },
  {
    type: QuestionnaireType.EOY_CAR_USAGE,
    title: "Pkw-Nutzung",
    description: "Privaten Nutzung des Betrieblichen PKW",
  },
  {
    type: QuestionnaireType.EOY_OFFICE_USAGE,
    title: "Häusliches Arbeitszimmer",
    description: "Angaben zu häuslichem Arbeitszimmer",
  },
  {
    type: QuestionnaireType.EOY_TRAVEL_EXPENSES,
    title: "Geschäftsreisen",
    description:
      "Verpflegungsmehraufwand & betrieblichen Nutzung des privaten PKW",
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX,
    title: "Private Steuererklärung",
    description: "Einkommenssteuererklärung",
    lastSupportedYear: 2021,
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX_BASIC_DATA,
    title: "Einkommensteuer",
    description: "Stammdaten",
    firstSupportedYear: 2022,
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX_BASIC_DATA_PARTNER,
    title: "Partner Einkommensteuer",
    description: "Partner Stammdaten",
    firstSupportedYear: 2022,
    showOnlyIfMatch: true,
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX_CHILD,
    title: "Einkommensteuer",
    description: "Kinder", // childName will be appended from context.
    firstSupportedYear: 2022,
    showOnlyIfMatch: true,
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX_PRIVATE_EXPENSES,
    title: "Einkommensteuer",
    description: "Private Ausgaben",
    firstSupportedYear: 2022,
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX_PRIVATE_EXPENSES_PARTNER,
    title: "Einkommensteuer",
    description: "Partner Private Ausgaben",
    firstSupportedYear: 2022,
    showOnlyIfMatch: true,
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX_ADDITIONAL_INCOME,
    title: "Einkommensteuer",
    description: "Zusätzliche Einkünfte",
    firstSupportedYear: 2022,
  },
  {
    type: QuestionnaireType.EOY_INCOME_TAX_ADDITIONAL_INCOME_PARTNER,
    title: "Einkommensteuer",
    description: "Zusätzliche Einkünfte Partner",
    firstSupportedYear: 2022,
    showOnlyIfMatch: true,
  },
];

export const EOY_INCOME_TAX_QUESTIONNAIRE_TYPES = [
  QuestionnaireType.EOY_INCOME_TAX_BASIC_DATA,
  QuestionnaireType.EOY_INCOME_TAX_BASIC_DATA_PARTNER,
  QuestionnaireType.EOY_INCOME_TAX_CHILD,
  QuestionnaireType.EOY_INCOME_TAX_PRIVATE_EXPENSES,
  QuestionnaireType.EOY_INCOME_TAX_PRIVATE_EXPENSES_PARTNER,
  QuestionnaireType.EOY_INCOME_TAX_ADDITIONAL_INCOME,
  QuestionnaireType.EOY_INCOME_TAX_ADDITIONAL_INCOME_PARTNER,
];

/**
 * Questionnaires that belong to the private tax return (income tax). Pre-2022
 * years use the single EOY_INCOME_TAX questionnaire. Everything else belongs
 * to the business tax return.
 */
export const PRIVATE_TAX_RETURN_QUESTIONNAIRE_TYPES = [
  QuestionnaireType.EOY_INCOME_TAX,
  ...EOY_INCOME_TAX_QUESTIONNAIRE_TYPES,
];
